import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import React, { useContext } from 'react';

import { BookmarkContext } from '../../Bookmark/BookmarkContext';
import CardList from '../../cards/CardList';
import { Loading } from '../Loading/Loading';
import { BookmarksWithGrid } from './BookmarksWithGrid';

export function Bookmarks() {
  const { mixedContent, loadingBookmarkedMixedContent } =
    useContext(BookmarkContext);

  const noBookmarks =
    (Array.isArray(mixedContent) && mixedContent.length === 0) ||
    mixedContent === undefined;

  return (
    <>
      <GridItem columnStartSm="1" columnEndSm="12">
        <Heading element="h2" variant="one">
          Jouw bewaarde content
        </Heading>
      </GridItem>

      {loadingBookmarkedMixedContent && (
        <GridItem columnStartSm="1" columnEndSm="12">
          <Loading />
        </GridItem>
      )}

      {!loadingBookmarkedMixedContent && noBookmarks && (
        <GridItem columnStartSm="1" columnEndSm="12">
          <span>Je hebt nog geen bewaarde content.</span>
        </GridItem>
      )}

      {Array.isArray(mixedContent) && mixedContent.length > 0 && (
        <CardList
          viewType="Default"
          items={mixedContent}
          renderCard={BookmarksWithGrid}
        />
      )}
    </>
  );
}
